import ReactDOM from 'react-dom';

// third party
import { HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

// project imports
import App from 'App';
import { store } from 'store';
import { registerServiceWorker } from './registerServiceWorker';

// style + assets
import 'assets/scss/style.scss';
import { AuthProvider } from 'Contextos/AuthContext';
import { NotificationProvider } from 'Contextos/NotificationContext';
import { ConfigMonitorProvider } from 'Contextos/ConfigMonitorContext';

// ==============================|| REACT DOM RENDER  ||============================== //

ReactDOM.render(
    <Provider store={store}>
        <AuthProvider>
            <NotificationProvider>
                <ConfigMonitorProvider>
                    <HashRouter>
                        <App />
                    </HashRouter>
                </ConfigMonitorProvider>
            </NotificationProvider>
        </AuthProvider>
    </Provider>,
    document.getElementById('root')
);

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.register();

// Registrar SW con manejo de actualización
registerServiceWorker();
